import { useEffect, useRef } from 'react';

type Callback = () => void;
type Delay = number | null;

const useInterval = (
  callback: Callback,
  delay: Delay,
  enabled = true,
): void => {
  const savedCallback = useRef(callback);

  savedCallback.current = callback;

  useEffect(() => {
    if (delay && enabled && savedCallback.current) {
      const id = setInterval(() => savedCallback.current(), delay);

      return () => {
        clearInterval(id);
      };
    }
  }, [delay, enabled]);
};

export default useInterval;
